'use client';

import { useGateValue } from '@statsig/react-bindings';
import type { ReactNode } from 'react';

import OneTrustConsentProvider from './OneTrustConsentProvider';
import OuraConsentManager from './OuraConsentManager';

interface ConsentManagerProviderProps {
  readonly children: ReactNode;
  readonly locale: string;
}

/**
 * ConsentManagerProvider handles the feature-gated switchover between
 * OuraConsentManager (legacy) and OneTrustConsentProvider (new)
 *
 * Feature gate: 'onetrust_segment_consent_manager'
 * - false: Use OuraConsentManager (supports server and client analytics)
 * - true: Use OneTrustConsentProvider (client analytics only)
 */
const ConsentManagerProvider = ({
  children,
  locale,
}: ConsentManagerProviderProps) => {
  const oneTrustConsentManagerEnabled = useGateValue(
    'onetrust_segment_consent_manager',
  );

  if (oneTrustConsentManagerEnabled) {
    // New OneTrust implementation - client analytics only
    return <OneTrustConsentProvider>{children}</OneTrustConsentProvider>;
  }

  // Legacy OuraConsentManager - supports server and client analytics
  return (
    <>
      {children}
      <OuraConsentManager locale={locale} />
    </>
  );
};

export default ConsentManagerProvider;
